import { API_URL } from '@assets/constants'
import { BankingRepository } from '@domain/repositories/BankingRepository'
import { bankingRepository } from '@microservices/repositories/BankingRepository'
import { Http } from '@microservices/instances/Http'

const http = new Http(API_URL)
export const bankingRepo: BankingRepository = bankingRepository(http)
